<template>
  <AIBasePanel
    ref="panel"
    body-class="tw:flex tw:flex-col tw:gap-4 tw:overflow-auto tw:py-4 tw:scroll-smooth"
    @close="emit('close')"
  >
    <template #toolbarCenter>
      <div class="tw:font-bold">
        {{ getLocaleText("ai_suggested_contacts_panel.title") }}
      </div>
    </template>

    <slot />

    <template v-if="hasResults && aiModalMinimise">
      <AISuggestedContactsFooter
        :assistant-panel="assistantPanel"
        :contact-list="contactList"
        data-testid="scrollable-contacts-footer"
        :media-release="mediaRelease"
        :selected-ids="selectedIds"
        :updating="updating"
        @add="emit('add')"
        @close="emit('close')"
      />
    </template>

    <template
      v-if="hasResults && !aiModalMinimise"
      #footer
    >
      <AISuggestedContactsFooter
        :assistant-panel="assistantPanel"
        :contact-list="contactList"
        data-testid="static-contacts-footer"
        :media-release="mediaRelease"
        :selected-ids="selectedIds"
        :updating="updating"
        @add="emit('add')"
        @close="emit('close')"
      />
    </template>
  </AIBasePanel>
</template>

<script setup lang="ts">
import { storeToRefs } from "pinia";
import { useTemplateRef } from "vue";

import { getLocaleText } from "shared/boot/i18n";
import AIBasePanel from "shared/components/AI/AIBasePanel.vue";
import AISuggestedContactsFooter from "shared/components/AI/AISuggestedContacts/AISuggestedContactsFooter.vue";
import { type ContactList, type MediaRelease } from "shared/resources";
import useAIStore from "shared/stores/ai";

interface AISuggestedContactsBasePanelProps {
  assistantPanel?: boolean;
  contactList?: ContactList;
  hasResults?: boolean;
  mediaRelease?: MediaRelease;
  selectedIds?: string[];
  updating?: boolean;
}

const aiStore = useAIStore();

const { aiModalMinimise } = storeToRefs(aiStore);

const { selectedIds = [] } = defineProps<AISuggestedContactsBasePanelProps>();

const emit = defineEmits(["close", "add"]);

const panel = useTemplateRef("panel");

function scrollToTop() {
  panel.value?.scrollToTop();
}

defineExpose({
  scrollToTop,
});
</script>
